import { useSyncExternalStore } from 'react';
import type { SyncStatus } from '@wiztime/sync';
import { isSyncEnabled } from '../app/sync';
import { useServices } from './useServices';

/** The sync status (state, last sync time, last error) of this device. */
export function useSyncStatus(): SyncStatus {
  const { sync } = useServices();
  return useSyncExternalStore(sync.subscribe, sync.getStatus);
}

/** Whether this device holds a sync configuration (see `AppSync.isConfigured`). */
export function useSyncConfigured(): boolean {
  const { sync } = useServices();
  return useSyncExternalStore(sync.subscribe, sync.isConfigured);
}

/**
 * Whether sync is on for this device: running, or configured but not (yet) running. Features that
 * must not act on data a second device shares (clearing, backup reminders) use this one, not the
 * status alone, which reads "disabled" until the sync code has loaded and in tabs that missed the setup.
 */
export function useSyncEnabled(): boolean {
  const status = useSyncStatus();
  const configured = useSyncConfigured();
  return configured || isSyncEnabled(status);
}
